import React from "react";

const I = ({children}) => React.cloneElement(children, {'aria-hidden': true, 'aria-label': true})

export default I

